import CadastroInterceptor from '../CadastroInterceptor'

const api = new CadastroInterceptor()

export default {
    get() {
      return api.get(`/pessoas/dados-cobranca`)
    },

    put(dados: any) {
      return api.put(`/pessoas/dados-cobranca`, dados)
    }
  }